import { useApiInfiniteQuery, type Api } from "../../../services/api";
import { useActiveLang } from "../../app/hooks/useActiveLang";

export type CongressContentItem =
  Api["get"]["/webapp/private/content/congress"]["output"]["body"]["docs"][number];

export const ALL_CONFERENCES_ID = "all_conferences";

type CongressContentQueryResult = {
  content: CongressContentItem[];
  contentIds: string;
  isLoading: boolean;
  isError: boolean;
  canFetchNextPage: boolean;
  fetchNextPage: () => void;
};

export function useGetCongressContentQuery(
  roomId: string,
  params: { congress?: string }
): CongressContentQueryResult {
  const { contentLang } = useActiveLang();

  const congress =
    params.congress === ALL_CONFERENCES_ID ? undefined : params.congress;

  const query = useApiInfiniteQuery("/webapp/private/content/congress", {
    query: {
      congress,
      limit: 20,
      language: contentLang,
      roomId,
    },
  });

  const content: CongressContentItem[] =
    query.state === "success" ? query.docs : [];
  const contentIds = content.map((doc) => doc.id).join(",");

  return {
    content,
    contentIds,
    isLoading: query.state === "pending",
    isError: query.state === "error",
    canFetchNextPage:
      query.state === "success" ? query.canFetchNextPage : false,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
  };
}
